<script>
export default {

}
</script>

<template>
  <div class="main">
      <div class="text">
        &emsp;&emsp;This laboratory focuses on the application of data acquisition technology and artificial intelligence. 
        Data acquisition technology is to extract useful information from big data. Because there are many theoretical methods of big data, 
        the application methods and timing are also different. How to use intelligent data acquisition technology to improve 
        the efficiency of information acquisition and The application to the smart Internet of Things system is the main field of research 
        in this laboratory. The application of artificial intelligence is another topic, including the application and research testing of 
        various evolutionary algorithms such as traditional neural networks, fuzzy theory, and genetic algorithms to deep learning theories.
      </div>
  </div>
 
</template>

<style lang="scss" scoped>
.main{
  display: flex;
  background-image: url("~@/assets/img/AIOT.jpg");
  height: 90%;
  >.text{
      margin-left: 20%;
      margin-right: 20%;
      width: 1600px;
      height: 280px;
      color: #000;
      font-size: 30px;
      margin-top: 2%;
      padding: 1%;
      border:2px grey solid;
      border-radius:5px;
      background-color:#eee;
  
  }
}


</style>